import { render, staticRenderFns } from "./CountriesListByRegion.vue?vue&type=template&id=2bef6170&scoped=true"
import script from "./CountriesListByRegion.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountriesListByRegion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CountriesListByRegion.vue?vue&type=style&index=0&id=2bef6170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef6170",
  null
  
)

export default component.exports